module.exports = __webpack_public_path__ + "img/qrcode.c97d070c.jpg";